export enum IntervalValueTypes {
  Last30Days = 0,
  Last90Days = 1,
  PastMonth = 2,
  Last12Month = 3,
  PastYear = 4,
  ThisYear = 5,
  Custom = 6,
}
